import React from "react";
import { NavLink } from "react-router-dom";
// import logo1 from "../asset/AirPets-Relocation-Services.png";
// import logo2 from "../asset/big-leap-consultancy.png";
// import logo3 from "../asset/dickey-asset-management.png";
// import logo4 from "../asset/ecommerce-development-company.webp";
// import logo5 from "../asset/harshyam-consultancy-service.png";
// import logo6 from "../asset/intage-india.png";
// import logo7 from "../asset/greenwave.png";

// const LogoSlider = () => {
//   return (
//     <div className="flex flex-wrap justify-center space-x-4 overflow-x-auto py-4">
//       <img src={logo1} alt="Client Logo 1" className="h-12 mb-4" />
//       <img src={logo2} alt="Client Logo 2" className="h-12 mb-4" />
//       <img src={logo3} alt="Client Logo 3" className="h-12 mb-4" />
//       <img src={logo4} alt="Client Logo 4" className="h-12 mb-4" />
//       <img src={logo5} alt="Client Logo 5" className="h-12 mb-4" />
//       <img src={logo6} alt="Client Logo 6" className="h-12 mb-4" />
//       <img src={logo7} alt="Client Logo 7" className="h-12 mb-4" />
//     </div>
//   );
// };

// const TrustedClients = () => {
//   return (
//     <div className="bg-white p-8 text-center">
//       <h2 className="text-2xl font-bold mb-4">Trusted Clients</h2>
//       <p className="mb-6">
//         Leverage agile frameworks to provide a robust synopsis for high-level
//         overviews. Iterative approaches to corporate strategy foster
//       </p>
//       <div className="flex justify-center items-center mt-4">
//         {/* <LogoSlider /> */}
//       </div>
//     </div>
//   );
// };

const BusinessPanel = ({ title, text, buttonText, to, dark }) => {
  return (
    <article className={`${dark ? "bg-teal-800 text-white" : "bg-slate-100 text-slate-900"} flex min-h-[300px] flex-col items-start justify-between p-8 sm:p-10`}>
      <div><p className={`text-xs font-bold uppercase tracking-[.18em] ${dark ? "text-teal-200" : "text-teal-700"}`}>Next step</p><h2 className="mt-3 max-w-lg text-3xl font-bold sm:text-4xl">{title}</h2>
      <p className={`mt-5 max-w-xl leading-7 ${dark ? "text-teal-50" : "text-slate-600"}`}>{text}</p></div>
      <NavLink to={to} className={`mt-8 inline-flex min-h-11 items-center rounded-md px-5 text-sm font-bold transition ${dark ? "bg-white text-teal-900 hover:bg-teal-50" : "bg-teal-700 text-white hover:bg-teal-800"}`}>
        {buttonText}
      </NavLink>
    </article>
  );
};

const BusinessSection = () => {
  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="mx-auto grid max-w-7xl px-5 lg:grid-cols-2 lg:px-8">
        <BusinessPanel
          title="How can we build your business?"
          text="We work with you to transform your organization, driving bold ideas and pragmatic solutions."
          buttonText="LET'S WORK TOGETHER"
          to="/contact"
          dark
        />
        <BusinessPanel
          title="Our people are our greatest assets"
          text="We work with you to transform your organization, driving bold ideas and pragmatic solutions."
          buttonText="COME WORK WITH US"
          to="/contact"
        />
      </div>
    </section>
  );
};

export default BusinessSection;
